import { t } from 'src/i18n';
import type { BleCapability } from './provisioning-types';
import type { ProvisioningTransport } from './provisioning-transport';
import { WebBluetoothTransport } from './web-bluetooth-transport';

/**
 * Lager riktig transport for gjeldende miljø. Improv-BLE kjører kun over Web
 * Bluetooth (web/Android-Chrome); iOS/Safari faller til captive-portal og når
 * aldri hit (capability = 'unsupported').
 */
export function createProvisioningTransport(capability: BleCapability): ProvisioningTransport {
  if (capability === 'web-bluetooth') {
    return new WebBluetoothTransport();
  }
  throw new Error(t('screens.networkConfig.errorUnsupportedEnv'));
}
